import { UIText1 } from '@cian/ui-kit';
import {
  IconActionChevronDownSmall16,
  IconActionChevronUpSmall16,
  IconPlaceholderUser16,
} from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import React from 'react';
import { getSafeGuestsCount } from 'shared/utils/getSafeGuestsCount';
import { pluralize } from 'shared/utils/pluralize';

import * as styles from './styles.css';

interface IGuestsControlButtonProps {
  isActive: boolean;
  value: number;
  minValue: number;
  maxValue: number;
  disabled: boolean;
  onClick(): void;
  ref?: React.Ref<HTMLDivElement>;
}

// Ref нужен для ui-kit компонента DropdownPopover, иначе ошибки в React дереве рендеринга
export function GuestsControlButton({
  isActive,
  value,
  minValue,
  maxValue,
  onClick,
  disabled,
  ref,
}: IGuestsControlButtonProps) {
  const safeValue = getSafeGuestsCount(value, minValue, maxValue);

  return (
    <div
      className={cx(styles['wrapper'], disabled && styles['disabled'], isActive && styles['active'])}
      onClick={disabled ? undefined : onClick}
      ref={ref}
      data-testid="guests-control-button"
      data-is-disabled={disabled}
    >
      <div className={styles['icon']}>
        <IconPlaceholderUser16 color="icon-main-default" />
      </div>
      <div className={styles['text']}>
        <UIText1>{pluralize(safeValue, ['гость', 'гостя', 'гостей'])}</UIText1>
      </div>
      <div className={styles['chevron']}>
        {isActive ? (
          <IconActionChevronUpSmall16 color="icon-main-default" />
        ) : (
          <IconActionChevronDownSmall16 color="icon-main-default" />
        )}
      </div>
    </div>
  );
}
